<template>
  <multiselect
    :class="wrapperClass"
    v-model="selected"
    :options="formattedOptions"
    :multiple="multi"
    :placeholder="placeholder"
    :searchable="searchable"
    :show-labels="false"
    :label="label"
    :track-by="trackBy"
    :allow-empty="allowEmpty"
    :taggable="taggable"
    @input="select"
  >
    <template #caret="{toggle}">
      <arrow-down class="multiselect__arrow absolute fill-current h-4 right-3 top-3 w-4 cursor-pointer" @mousedown.prevent.stop="toggle"></arrow-down>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import ArrowDown from '../assets/icons/chevron-down.svg';

export default {
  name: 'MultiSelect',
  components: {
    Multiselect,
    ArrowDown
  },
  props: {
    value: { type: [Array, Number, String], default: () => [] },
    options: {},
    placeholder: { type: String, default: 'Select' },
    searchable: { type: Boolean, default: false },
    variant: { type: String, default: 'base' },
    trackBy: { type: String, default: 'value' },
    label: { type: String, default: 'text' },
    allowEmpty : { type: Boolean, default: true },
    taggable: { type: Boolean, default: false },
    multi: { type: Boolean, default: true }
  },
  data() {
    return {
      selected: []
    };
  },
  watch: {
    value: {
      handler: function (val) {
        if (!this.multi) this.selected = val ? { [this.label]: val, value: val } : {};
        else {
          this.selected = val.map(item => {
            if (typeof item === 'object') return item;
            else return { [this.label]: item, value: item };
          });
        }
      },
      immediate: true
    },
  },
  computed: {
    formattedOptions() {
      if (!this.options) return this.navigationPages || [];
      if (this.options[0] && this.options[0].value !== 'undefined') return this.options;
      else
        return this.options.map(option => {
          return { [this.label]: option, value: option };
        });
    },
    navigationPages() {
      let pages = this.$store.getters.onPageNavigation;
      return pages.map(page => {
        return { [this.label]: page.name, value: page.name };
      });
    },
    wrapperClass() {
      return {
        'gd-multiselect': true,
        'gd-multiselect--dark': this.variant === 'dark',
      };
    }
  },
  methods: {
    select(items) {
      const selections = Array.isArray(items) ? items.map(item => item.value) : items?.value;
      this.$emit('input', this.multi ? JSON.parse(JSON.stringify(items)) : items?.value);
      this.$emit('change', selections || []);
    }
  }
};
</script>
